var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.getMenuFun),function(item,i){return _c('li',{key:i},[(_vm.eventid[item.eid]!==undefined||item.eid=='0')?_c('router-link',{class:item.cl,attrs:{"to":item.path,"active-class":"active"}},[_c('i',{class:[item.class ? item.class : '',item.icon]}),_vm._v(" "+_vm._s(item.name)+"\n      ")]):_vm._e()],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b35fe28","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Submenu.vue
// module id = null
// module chunks = 